// extracted by mini-css-extract-plugin
export default {"jadaPuppy":"J1T00o","container":"A6YVkI"};